import data from './production.json';

export const environment = {
  production: true,
  deploy_url: (<any>data).deploy_url,
  googleClientId: '887955561517-8clith9gtt2qvnjnlaoie54ieogmg8kj.apps.googleusercontent.com',
  locationApi: 'https://appic-geocoder.azurewebsites.net',
  locationAccessToken: 'afpbf2abeaf290cf978a7bb5360dc180ffec9db0b7ec94ad2440a37a5ec955150a8',
  version: data.version,
  branch_name: (<any>data).branch_name,
  last_commit_time: (<any>data).last_commit_time,
  last_commit_author: (<any>data).last_commit_author,
};
